// extracted by mini-css-extract-plugin
export default {"list":"invoice-price-corrections_list__8R-cF","row":"invoice-price-corrections_row__Qpmk7","value":"invoice-price-corrections_value__OKLxf"};